<template>
  <div >
    <el-dialog  title="关联合同" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"  :visible="GLHTflag" width="1000px" center>
      <div>
        <el-form  :inline="true"  :model="searchFrom1"  class="demo-form-inline"  label-width="80px"  size="mini"  >
          <el-form-item label="合同编号">
            <el-input  placeholder="" v-model="searchFrom1.contractNo"></el-input>
          </el-form-item>
          <el-button type="primary" @click="searchFn1" >查询</el-button>
        </el-form>
        <el-table height="400px" size="mini" ref="tabref" :data="detailsData" style="width:100%" @row-dblclick="dbSelected" border center>
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index"  label="序号" width="60"></el-table-column>
          <el-table-column width="100" label="生效状态">
            <template slot-scope="scope">
              <div class="textColor backColor1" v-show="scope.row.contractStates == '1'">未生效</div>
              <div class="textColor backColor2" v-show="scope.row.contractStates == '2'">已生效</div>
              <div class="textColor backColor3" v-show="scope.row.contractStates == '3'">超期预警</div>
              <div class="textColor backColor4" v-show="scope.row.contractStates == '4'">已过期</div>
            </template>
          </el-table-column>
          <el-table-column prop="contractNo" width="220" label="合同编号"></el-table-column>
          <el-table-column prop="contractStartDate" width="130" :formatter="dateFormat" label="有效开始日期"></el-table-column>
          <el-table-column prop="contractEndDate" width="130" :formatter="dateFormat" label="有效结束日期"></el-table-column>
          <el-table-column prop="createUser"  label="创建人"></el-table-column>
          <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
        </el-table>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { findCustomerContractList } from '@/api/newTMS'
import { dateTimeFormat, dateFormat } from '@/utils/util'
export default {
  name: 'guanlianhetong',
  props: {
    GLHTflag: {
      type: Boolean,
      default: false
    },
    goodform: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      searchFrom1: {
        customerId: this.goodform.payCustomerId
      },
      detailsData: []
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.searchFn1()
  },
  methods: {
    searchFn1 () {
      findCustomerContractList(this.searchFrom1).then(res => {
        this.loading = false
        this.detailsData = res
      })
    },
    dbSelected (row) {
      this.$set(this.goodform, 'salesContract', row.contractNo)
      this.$set(this.goodform, 'contractEndDate', row.contractEndDate)
      this.$emit('update:GLHTflag', false)
    },
    closeDialog () {
      this.$emit('update:GLHTflag', false)
    }

  },
  destroyed () {
  }
}
</script>

<style scoped lang='less'>
 .textColor{
    color: #fff;
    border-radius: 3px;
 }
 .backColor1{
    background-color:#a4adb3;
 }
 .backColor2{
    background-color:#81b337;
 }
 .backColor3{
    background-color:#e99d42;
 }
 .backColor4{
    background-color:#d51212;
 }
</style>
